import axios from 'axios';

/**
 * Copyright 2022, IntraLinks, Inc, All rights reserved.
 */
var axiosInstance = axios.create({
  baseURL: '',
  withCredentials: true
});
var IAMUrl = '/v3/apis/il-iam/profile/linkedidentities';
var switchIdentityUrl = '/v3/apis/il-iam/profile/switchIdentity';
var GatewaySessionUrl = '/v3/apis/il-gateway/session';

export { GatewaySessionUrl, IAMUrl, axiosInstance as default, switchIdentityUrl };
